import React from 'react';
import { FormControlLabel, MenuItem, Stack, Switch, TextField } from '@mui/material';
import BotNumberDropdown from '../../../../../components/Shared/BotNumberDropdown/index.tsx';
import TemplateDropdown from '../../../../../components/Shared/TemplateDropdown/TemplateDropdown.tsx';
import { FORM_STUDIO_COPY } from '../../constants/formStudioConfig';

const FREQUENCIES = ['One-time', 'Hourly', 'Daily', 'Weekly', 'Monthly'];

export default function LeadSummarySchedulerForm({ form, onChange, organisationId = '' }) {
  const copy = FORM_STUDIO_COPY.automations.scheduled;
  const update = (patch) => onChange?.({ ...form, ...patch });

  return (
    <Stack spacing={2}>
      <TextField
        select
        label={copy.frequency}
        size="small"
        fullWidth
        value={form.frequency || 'Daily'}
        onChange={(event) => update({ frequency: event.target.value })}
      >
        {FREQUENCIES.map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label={copy.sendTime}
        size="small"
        fullWidth
        value={form.sendTime || '09:00'}
        onChange={(event) => update({ sendTime: event.target.value })}
      />
      <TemplateDropdown
        value={form.template?.name ? form.template : null}
        dropdownFilters={{
          organisationId: organisationId || '',
          botNumber: form.template?.bot_number || form.notification_config?.bot_number || '',
        }}
        onChange={(val) => {
          update({
            template: {
              name: val?.name || '',
              bot_number: form.template?.bot_number || '',
            },
            notification_config: {
              ...(form.notification_config || {}),
              template_id: val?.name || '',
            },
          });
        }}
        label={copy.template}
      />
      <BotNumberDropdown
        organisation={organisationId ? { organisation_id: organisationId } : null}
        label={copy.botNumber}
        value={
          form.template?.bot_number
            ? { wa_phone_number: form.template.bot_number }
            : null
        }
        onChange={(val) => {
          update({
            template: {
              ...(form.template || {}),
              bot_number: val?.wa_phone_number || '',
            },
            notification_config: {
              ...(form.notification_config || {}),
              bot_number: val?.wa_phone_number || '',
            },
          });
        }}
      />
      <FormControlLabel
        control={
          <Switch
            checked={form.active !== false}
            onChange={(event) => update({ active: event.target.checked })}
          />
        }
        label={copy.activeLabel}
      />
    </Stack>
  );
}
